// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__C5On9","column_metrics":"MemorandumValues_column_metrics__m+mjw"};